import { render, staticRenderFns } from "./addBatchData.vue?vue&type=template&id=1c966a3d&scoped=true&"
import script from "./addBatchData.vue?vue&type=script&lang=js&"
export * from "./addBatchData.vue?vue&type=script&lang=js&"
import style0 from "./addBatchData.vue?vue&type=style&index=0&id=1c966a3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c966a3d",
  null
  
)

export default component.exports